import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 32px 32px;
  font-family: 'Sora', sans-serif;

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;

export const SaleContainer = styled.div`
  padding: 24px;
  background-color: #f7f7f7;
  border-radius: 5px;
  margin-top: 20px;

  div.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
      font-size: 22px;
      color: #101d40;
      font-weight: 600;
    }
  }

  div.inputs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;

    @media only screen and (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 20px;
  }
`;
